import gql from "graphql-tag";
import { benefitFragment } from "../fragments";

export default {
  upsertMutation: gql`
    mutation m0(
      $id: ID
      $insurerId: ID
      $isPolicy: Boolean
      $restrictedFields: [String]
      $type: String
      $name: String
      $tag: String
      $meta: JSONObject
    ) {
      upsertBenefit(
        input: {
          id: $id
          insurerId: $insurerId
          isPolicy: $isPolicy
          restrictedFields: $restrictedFields
          type: $type
          name: $name
          meta: $meta
          tag: $tag
        }
      ) {
        benefit {
          ...Benefit
        }
      }
    }
    ${benefitFragment}
  `,
};
